'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MoonCloudyIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.1 11.9C19.35 11.74 19.59 11.54 19.82 11.32C20.38 10.76 20.76 10.09 20.94 9.37996C19.49 9.76996 17.89 9.38996 16.76 8.25996C15.63 7.12996 15.26 5.52996 15.64 4.07996C14.93 4.25996 14.26 4.63996 13.7 5.19996C12.73 6.16996 12.31 7.49996 12.46 8.76996M21.25 15.71C21.25 16.46 21.07 17.16 20.74 17.78C20 19.22 18.49 20.21 16.75 20.21H9C6.99 20.21 5.2 19.26 4.06 17.78C3.24 16.73 2.75 15.4 2.75 13.96C2.75 10.51 5.55 7.70996 9 7.70996C11.64 7.70996 13.89 9.33996 14.81 11.65C15.4 11.37 16.06 11.21 16.75 11.21C19.24 11.21 21.25 13.22 21.25 15.71Z",
        stroke: "currentColor",
        strokeMiterlimit: 10
      }
    )
  }
);
const VpMoonCloudyIcon = forwardRef(MoonCloudyIcon);

export { VpMoonCloudyIcon as default };
